export default "__VITE_ASSET__CZdlbErk__"